import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export const HttpMethod ={
  POST:'Post',
  PUT :'Put',
  DELETE:'Delete',
  GET:'Get',
  GETWITHOUTHEADERS: 'GetWithoutHeader'
}

export enum AlertInfo {
  QUESTION = 'question',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  CENTER = 'center'
}

// to check null or undefined
export function checkNullOrUndefined(val: null | undefined) {
  if (val === null || val === undefined) {
    return true;
  } else {
    return false;
  }
}


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private spinner: NgxSpinnerService,
    private http: HttpClient, 
    private toaster: ToastrService,

  ) { }

  apiHandler(methodType, url, requestObj) {

    switch (methodType) {
      case HttpMethod.POST:
        return this.commonPostHandler(url, requestObj);
      case HttpMethod.PUT:
        return this.commonPutHandler(url, requestObj);
      case HttpMethod.DELETE:
        return this.commonDeleteHandler(url);
      case HttpMethod.GET:
        return this.commonGetHandler(url);
      case HttpMethod.GETWITHOUTHEADERS:
        return this.commonGetByWithoutHandler(url, requestObj);
    }
  }

  commonPostHandler(url: string, data: any): Observable<any> {
    return this.http.post(url, data, { headers: this.getToken() });
  }

  commonGetHandler(url: string): Observable<any> {
    return this.http.get(url, { headers: this.getToken() });
  }

  commonGetByHandler(url: string): Observable<any> {
    return this.http.get(url, { headers: this.getToken() });
  }

  commonPutHandler(url: string, data: any): Observable<any> {
    return this.http.put(url, data, { headers: this.getToken() });
  }

  commonDeleteHandler(url: string): Observable<any> {
    return this.http.delete(url, { headers: this.getToken() });
  }

  commonGetByWithoutHandler(url: string, data): Observable<any> {
    return this.http.get(url, { headers: data });
  }

  getToken(): any {
    return "Authorization:Bearer " + localStorage.getItem("A_accesstoken")
  }

  commonApiCall(obj, callBack) {
    const requestObj = obj.requestObj || null;
    // obj.showPopup = obj.hasOwnProperty('showPopup') ? obj.showPopup : false;
    obj.showSpinner = obj.hasOwnProperty('showSpinner') ? obj.showPopup : true;
    if (obj.showSpinner) {
      this.spinner.show();
    }
    this.apiHandler(obj.methodType, obj.url, requestObj).pipe(take(1)).subscribe((res) => {
      if (res.status === 1) {
        if (obj.methodType == HttpMethod.POST || obj.methodType == HttpMethod.PUT || obj.methodType == HttpMethod.DELETE) {
          this.toaster.success(res.message);

        }
        callBack(res, true);
        // if(obj.showPopup) {
        //   this.getMessages(res, AlertInfo.SUCCESS, obj.methodType);
        // }
      } else if (res.status === 2) {
        if (obj.methodType == HttpMethod.POST || obj.methodType == HttpMethod.PUT || obj.methodType == HttpMethod.DELETE) {
          this.toaster.warning(res.message);
        }
        this.spinner.hide();
      } else if (res.status === 3) {
        if (obj.methodType == HttpMethod.POST || obj.methodType == HttpMethod.PUT || obj.methodType == HttpMethod.DELETE) {
          this.toaster.error(res.message);
        }
        this.spinner.hide();
      } else if (res.status === 4) {
        callBack(res, 'showControlError');
      } else {
        this.spinner.hide();
        callBack(res, false);
      }
    }, (error) => {
      this.spinner.hide();
      this.toaster.error(error);

    }
    );
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  formatDate(date = new Date(), m?) {
    var d = new Date(date),
      month = '' + (d.getMonth() + (m ? 0 : 1)),
      day = '' + d.getDate(),
      year = '' + d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  getFileName(file) {
    return file && file.split('/').pop();
  }

  getFileExtension(file) {
    return file && file.split('.').pop();
  }

}
